// Dawn theme cart settings override
document.addEventListener('DOMContentLoaded', function() {
  // Try to override cart settings in window.theme
  setTimeout(function() {
    if (window.theme && window.theme.settings) {
      // Force cart type to drawer
      window.theme.settings.cart_type = 'drawer';
      
      // Disable cart redirection if that setting exists
      if (window.theme.settings.hasOwnProperty('cart_redirect')) {
        window.theme.settings.cart_redirect = false;
      }
    }
    
    // Patch any cart URLs to prevent redirection
    const links = document.querySelectorAll('a[href^="/cart/add"]');
    links.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Extract the variant ID from the URL
        const url = new URL(link.href, window.location.origin);
        const variantId = url.searchParams.get('id');
        
        if (variantId) {
          // Add to cart via AJAX
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          })
          .then(response => response.json())
          .then(data => {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
            if (typeof window.triggerWeglotRetranslation === 'function') window.triggerWeglotRetranslation();
          })
          .catch(error => console.error('Error:', error));
        }
      });
    });
  }, 100);
});